import { gql } from '@/features/graphql/generated'

export const OpenTabsDocument = gql(/* GraphQL */ `
    query OpenTabs {
        deliveryPaymentMappings {
            deliveryTypeCategory
            paymentTypes
        }
    }
`)

export const OpenTabDetailDocument = gql(/* GraphQL */ `
    query OpenTabDetail($uuid: ID!) {
        openTab(uuid: $uuid) {
            ...OpenTabDetail
        }
    }
`)

export const OpenTabCatalogDocument = gql(/* GraphQL */ `
    query OpenTabCatalog {
        categories {
            uuid
            name
            products {
                ...OpenTabCatalogProduct
            }
            subcategories {
                uuid
                name
                products {
                    ...OpenTabCatalogProduct
                }
            }
        }
    }
`)

export const OpenTabDraftCartDocument = gql(/* GraphQL */ `
    query OpenTabDraftCart($cartKey: ID!) {
        cart(cartKey: $cartKey) {
            ...OpenTabCart
        }
    }
`)
